// extracted by mini-css-extract-plugin
module.exports = {"myname_desktop":"header-module--myname_desktop--2fLr7","myname_mobile":"header-module--myname_mobile--2FX_j"};